// ============================================================================
// DEFAULT NOZZLE DATA
// ============================================================================
export const DEFAULT_TANK_NOZZLES = [
  { designation: "Injeção Químico", qty: "1", dn: "25", pn: "16", unitPrice: "", price: "" },
  { designation: "Purga Ar", qty: "1", dn: "25", pn: "16", unitPrice: "", price: "" },
  { designation: "Coletor Instrumentação", qty: "1", dn: "25", pn: "16", unitPrice: "", price: "" },
  { designation: "Anti-Vácuo", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Válvula Segurança", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Entrada Vapor", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Entrada Homem", qty: "1", dn: "500", pn: "10", price: "" },
  { designation: "Indicador Nível", qty: "2", dn: "25", pn: "16", unitPrice: "", price: "" },
  { designation: "Injeção Vapor", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Água Alimentação", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Reserva", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Dreno", qty: "1", dn: "50", pn: "16", unitPrice: "", price: "" },
  { designation: "Transmissor Temperatura", qty: "1", dn: "15", pn: '1/2" BSP', unitPrice: "", price: "" },
  { designation: "Termómetro", qty: "1", dn: "15", pn: '1/2" BSP', unitPrice: "", price: "" },
  { designation: "Entrada Retorno Bombas", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
];



export const DEFAULT_TOWER_NOZZLES = [
  { designation: "Vapor Equilíbrio", qty: "1", dn: "20", pn: "16", unitPrice: "", price: "" },
  { designation: "Porta Homem", qty: "1", dn: "500", pn: "10", price: "" },
  { designation: "Entrada Água Make-up", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
  { designation: "Respiro", qty: "1", dn: "25", pn: "16", unitPrice: "", price: "" },
  { designation: "Entrada Condensados", qty: "1", dn: "", pn: "16", unitPrice: "", price: "" },
];


export const CALCULATED_NOZZLES = [
  "Entrada Completar",
  "Entrada Vapor",
  "Injeção Vapor",
  "Entrada Água Make-up",
  "Água Alimentação",
  "Entrada Condensados",
  "Reserva",
  "Entrada Retorno Bombas",
  "Anti-Vácuo"
];

// ============================================================================
// FORM FIELDS CONFIGURATION
// ============================================================================
// `title`/`label` values below are i18next translation keys, resolved via
// t(key) at render time in DataInputStep.js. `options` are actual business
// values submitted to the backend and must stay untranslated.
export const NOZZLE_SECTION_KEY = "budgetForm.sections.nozzleList";

export const editorFields = [
  {
    type: "section",
    title: "budgetForm.sections.generalInfo",
    fields: [
      { name: "propose", label: "budgetForm.fields.propose", type: "text", required: true },
      { name: "location", label: "budgetForm.fields.location", type: "text" },
      { name: "enviroment", label: "budgetForm.fields.environment", type: "select", options: ["Indoor", "Outdoor"], required: true },
      { name: "minTemperature", label: "budgetForm.fields.minTemperature", type: "number" },
      { name: "projectCode", label: "budgetForm.fields.projectCode", type: "select", options: ["EN", "ASME"], required: true },
      { name: "reservoirMaterial", label: "budgetForm.fields.reservoirMaterial", type: "select", options: ["Aço Carbono", "Aço Inoxidável"], required: true },
      { name: "towerMaterial", label: "budgetForm.fields.towerMaterial", type: "select", options: ["Aço Carbono", "Aço Inoxidável"], required: true },
      { name: "language", label: "budgetForm.fields.documentationLanguage", type: "select", options: ["Português", "Inglês"], defaultValue: "Português" },
    ]
  },
  {
    type: "section",
    title: "budgetForm.sections.technicalData",
    fields: [
      { name: "degassingCapacity", label: "budgetForm.fields.degassingCapacity", type: "number", required: true },
      { name: "maxOxygenContent", label: "budgetForm.fields.maxOxygenContent", type: "number", required: true },
      { name: "mawt", label: "budgetForm.fields.mawt", type: "number", required: true },
      { name: "mawp", label: "budgetForm.fields.mawp", type: "number", required: true },
      { name: "operatingTemperature", label: "budgetForm.fields.operatingTemperature", type: "number", required: true },
      { name: "operatingPressure", label: "budgetForm.fields.operatingPressure", type: "number", required: true },
      { name: "availableSteamTemperature", label: "budgetForm.fields.availableSteamTemperature", type: "number", required: true },
      { name: "availableSteamPressure", label: "budgetForm.fields.availableSteamPressure", type: "number", required: true },
      { name: "vacuumPressure", label: "budgetForm.fields.vacuumPressure", type: "select", options: ["Sim (Absoluto)", "Sim (-0.6 barg)", "Não"], required: true },
      { name: "corrosionAllowance", label: "budgetForm.fields.corrosionAllowance", type: "number" },
      //{ name: "separateInlets", label: "Entrada separada para água make-up e condensado", type: "select", options: ["Sim", "Não"], required: true },
      { name: "minCondensateTemperature", label: "budgetForm.fields.minCondensateTemperature", type: "number", required: true },
      { name: "maxSprayFlowRate", label: "budgetForm.fields.maxSprayFlowRate", type: "number", required: true },
      { name: "storageTime", label: "budgetForm.fields.storageTime", type: "number", required: true },
      { name: "retentionTime", label: "budgetForm.fields.retentionTime", type: "number", required: true },
      { name: "normalOperatingLevel", label: "budgetForm.fields.normalOperatingLevel", type: "number", required: true },
      { name: "condensateFlowRate", label: "budgetForm.fields.condensateFlowRate", type: "number", required: true },
      { name: "makeUpWaterTemperature", label: "budgetForm.fields.makeUpWaterTemperature", type: "number", defaultValue: 15 },
    ]
  },
  {
    type: "section",
    title: NOZZLE_SECTION_KEY,
    fields: [
      { name: "nozzleList", label: "budgetForm.fields.nozzleList", type: "custom", defaultValue: { tankNozzles: DEFAULT_TANK_NOZZLES, towerNozzles: DEFAULT_TOWER_NOZZLES } }
    ]
  },
  {
    type: "section",
    title: "budgetForm.sections.accessoriesConstruction",
    fields: [
      { name: "steelStructureRequired", label: "budgetForm.fields.steelStructureRequired", type: "select", options: ["Sim", "Não"], required: true },
      { name: "insulationSupport", label: "budgetForm.fields.insulationSupport", type: "select", options: ["Sim", "Não"], required: true },
      { name: "insulation", label: "budgetForm.fields.insulation", type: "select", options: ["Sim", "Não"], required: true },
      { name: "platformSupports", label: "budgetForm.fields.platformSupports", type: "select", options: ["Sim", "Não"], required: true },
      { name: "platformsAndLadders", label: "budgetForm.fields.platformsAndLadders", type: "select", options: ["Sim", "Não"], required: true },
      { name: "vacuumBreakers", label: "budgetForm.fields.vacuumBreakers", type: "select", options: ["Sim", "Não"], required: true },
      { name: "orificePlates", label: "budgetForm.fields.orificePlates", type: "select", options: ["Sim", "Não"], required: true },
      { name: "paintingScheme", label: "budgetForm.fields.paintingScheme", type: "select",options: ["Standard", "CUI + C4"], required: true },
      { name: "packaging", label: "budgetForm.fields.packaging", type: "select", options: ["Sim", "Não"], required: true },
    ]
  },
  {
    type: "section",
    title: "budgetForm.sections.engineeringDocumentation",
    fields: [
      { name: "structuralCalculation", label: "budgetForm.fields.structuralCalculation", type: "select", options: ["Sim", "Não"] },
      { name: "drawing2D3D", label: "budgetForm.fields.drawing2D3D", type: "select", options: ["Sim", "Não"], defaultValue: "Sim" },
      { name: "manual", label: "budgetForm.fields.manual", type: "select", options: ["Sim", "Não"] },
      { name: "transportDrawing", label: "budgetForm.fields.transportDrawing", type: "select", options: ["Sim", "Não"] },
      { name: "qualityDocumentation", label: "budgetForm.fields.qualityDocumentation", type: "select", options: ["Sim", "Não"] },
      { name: "commissioning", label: "budgetForm.fields.commissioning", type: "select", options: ["Sim", "Não"] },
      { name: "transport", label: "budgetForm.fields.transport", type: "select", options: ["Sim", "Não"] },
    ]
  },
];

// ============================================================================
// FIELD PATH MAP
// ============================================================================
export const fieldPathMap = {
  // projectInfo
  propose: ["projectInfo", "propose"],
  projectCode: ["projectInfo", "projectCode"],
  location: ["projectInfo", "location"],
  enviroment: ["projectInfo", "enviroment"],
  minTemperature: ["projectInfo", "minTemperature"],
  language: ["projectInfo", "language"],
  towerMaterial: ["projectInfo", "towerMaterial"],
  reservoirMaterial: ["projectInfo", "reservoirMaterial"],

  // technicalData
  degassingCapacity: ["technicalData", "degassingCapacity"],
  maxOxygenContent: ["technicalData", "maxOxygenContent"],
  mawt: ["technicalData", "mawt"],
  mawp: ["technicalData", "mawp"],
  operatingTemperature: ["technicalData", "operatingTemperature"],
  operatingPressure: ["technicalData", "operatingPressure"],
  availableSteamTemperature: ["technicalData", "availableSteamTemperature"],
  availableSteamPressure: ["technicalData", "availableSteamPressure"],
  vacuumPressure: ["technicalData", "vacuumPressure"],
  corrosionAllowance: ["technicalData", "corrosionAllowance"],
  separateInlets: ["technicalData", "separateInlets"],
  minCondensateTemperature: ["technicalData", "minCondensateTemperature"],
  maxSprayFlowRate: ["technicalData", "maxSprayFlowRate"],
  storageTime: ["technicalData", "storageTime"],
  retentionTime: ["technicalData", "retentionTime"],
  normalOperatingLevel: ["technicalData", "normalOperatingLevel"],
  condensateFlowRate: ["technicalData", "condensateFlowRate"],
  makeUpWaterTemperature: ["technicalData", "makeUpWaterTemperature"],

  // nozzleList
  nozzleList: ["nozzleList"],

  // accessoriesAndConstruction
  steelStructureRequired: ["accessoriesAndConstruction", "steelStructureRequired"],
  insulationSupport: ["accessoriesAndConstruction", "insulationSupport"],
  insulation: ["accessoriesAndConstruction", "insulation"],
  platformSupports: ["accessoriesAndConstruction", "platformSupports"],
  platformsAndLadders: ["accessoriesAndConstruction", "platformsAndLadders"],
  vacuumBreakers: ["accessoriesAndConstruction", "vacuumBreakers"],
  orificePlates: ["accessoriesAndConstruction", "orificePlates"],
  packaging: ["accessoriesAndConstruction", "packaging"],
  paintingScheme: ["accessoriesAndConstruction", "paintingScheme"],

  // engineeringAndDocumentation
  structuralCalculation: ["engineeringAndDocumentation", "structuralCalculation"],
  drawing2D3D: ["engineeringAndDocumentation", "drawing2D3D"],
  manual: ["engineeringAndDocumentation", "manual"],
  transportDrawing: ["engineeringAndDocumentation", "transportDrawing"],
  qualityDocumentation: ["engineeringAndDocumentation", "qualityDocumentation"],
  commissioning: ["engineeringAndDocumentation", "commissioning"],
  transport: ["engineeringAndDocumentation", "transport"],
};

// ============================================================================
// UTILITIES
// ============================================================================
export const flattenFields = (fields) => {
  const flatFields = [];
  fields.forEach((field) => {
    if (field.type === "section") {
      flatFields.push(...field.fields);
    } else {
      flatFields.push(field);
    }
  });
  return flatFields;
};

export const isValidEmail = (email) => {
  return /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(email);
};

export const formatValue = (value, fieldName) => {
  if (fieldName === "enviroment" && value !== undefined) {
    return value === "INDOOR" ? "Indoor" : "Outdoor";
  } else if (fieldName === "language") {
    return value === undefined || value === "PT" ? "Português" : "Inglês";
  }
  return value;
};

export const getInitialFormData = (fields, initialData) => {
  const flatFields = flattenFields(fields);
  return flatFields.reduce((acc, field) => {
    const path = fieldPathMap[field.name] || ["projectInfo", field.name];
    let value = initialData;
    for (const key of path) {
      value = value?.[key];
      if (value === undefined) break;
    }

    // Special handling for custom fields (like nozzleList)
    // Treat undefined, null, or empty string as missing so defaultValue is used
    if (field.type === "custom" && (value === undefined || value === null || value === "")) {
      acc[field.name] = field.defaultValue ?? null;
      return acc;
    }

    acc[field.name] = formatValue(value, field.name) ?? field.defaultValue ?? (field.type === "file" ? null : "");
    return acc;
  }, {});
};
